//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { intervalToDuration } from 'date-fns';
import { faPlay, faPause } from '@fortawesome/pro-solid-svg-icons';
import { albumArtUrl } from '@motionelements/product2025/src/helpers/productMap.js';

export default {
  name: 'PreviewAudio',
  components: {
    AudioPlayer: () => import('@motionelements/product2025/src/components/AudioPlayer.vue'),
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faPause,
      faPlay,
      //
      play: false,
      currentTime: 0,
    };
  },
  mounted() {
    if (!process.server && this.peaksUrl) {
      // fetch on client side only
      // const audioPeaksUrl = _.get(this.element, 'previews.json.url');
      console.log('audioPeaksUrl', this.peaksUrl);
      // if (audioPeaksUrl) {
      this.$store.dispatch('product/fetchAudioPeaks', this.peaksUrl);
      // }
    }
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
      audioPeaks: state => state.product.audioPeaks,
    }),
    ...mapGetters({
      duration: 'product/duration',
    }),
    peaksUrl() {
      return this._.get(this.element, 'previews.json.url');
    },
    showPlayer() {
      return !this.peaksUrl || this.audioPeaks;
    },
  },
  methods: {
    albumArtUrl,
    togglePlay() {
      this.play = !this.play;
    },
    renderDuration(seconds) {
      if (!seconds) return '00:00';

      const d = intervalToDuration({ start: 0, end: seconds * 1000 });
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.minutes ?? 0)}:${pad(d.seconds ?? 0)}`;

      // this is wrong, renders 30:00
      // return format(new Date(this.duration * 1000), 'mm:ss');
    },
    handleTimeUpdate(currentTime) {
      this.currentTime = currentTime;
    },
  },
};
